<template>
  <div>
    <vs-popup class="sms-modal" title="Verstuur SMS" :active.sync="showPopup">
      <div class="vx-row">
        <div class="vx-col sm:w-1/1 w-full mb-2">

          <vs-textarea
            placeholder="Schrijf hier jouw sms, maximaal 480 karakters!"
            v-model="message"
            rows="10"
            cols="8"
            maxlength="480"
          >
          </vs-textarea>
          <p class="bulkwarning" for="textarea">
            <i>
              Je staat op het punt om naar alle actieve bezorgers een SMS te
              versturen.
            </i>
          </p>
        </div>
      </div>
      <vs-button class="smsbutton mr-3 w-full mb-2" @click="sendGlobalText">Verstuur sms</vs-button>
    </vs-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPopup: false,
      massActive: false,
      message: ""
    };
  },
  methods: {
      sendGlobalText() {
          let data = {
              message: this.message
          };
          this.$http
                .post('/v1/text/send', data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then(() => {
                        this.showPopup = false;
                            this.$vs.notify({
                                title: "Gelukt!",
                                text: "Bericht is naar iedereen verstuurd per sms!",
                                color: "green",
                                position: "top-center",
                            });
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
      }
  },
  mounted() {
    this.isMounted = true;
    this.$events.listen("open-sms-modal", () => {
      this.showPopup = true;
    });
  },
};
</script>
<style>
::placeholder {
  font-size: 0.9em;
}

.bulkwarning {
  font-size: 0.85em;
  margin-left: 5em;
}
</style>
